/* Colectiile de tesatura Agache (Luna, Manila, Enjoy Lux, Milton, Piano, Spello, Maya, Zoya):
   datele lor, descrierea si ingrijirea, cu toate culorile. Intr-un singur loc pentru doi
   cititori, ca textele sa nu se dezica intre ele:
     - configuratorul (cfg_COLLECTIONS, assets/ixaria-configurator.js);
     - panoul „Colecția …" de pe pagina produsului, deschis de iconita (i) de langa
       materialul ales (openMaterialInfo, assets/ixaria-pdp.js).
   Se incarca inaintea amandurora: in ixaria-mobile-pdp.liquid inaintea lui ixaria-pdp.js
   (configuratorul din pagina vine mult mai tarziu, pus de ixaria-cfg-overlay.js), in
   ixaria-configurator.liquid inaintea configuratorului.

   Descrierile (desc) sunt cele din „Ghid materiale" (agache.ro/blogs/news/ghid-detaliat-in-
   alegerea-materialului-pentru-canapele) si se editeaza din editorul de teme: Setări temă →
   „Colecții de materiale" (snippets/ixaria-collections-data.liquid le pune in pagina). Cele
   de aici raman doar rezerva, pentru un camp golit.
   Compozitia, Martindale, rezistenta culorii la lumina si pilling-ul sunt din fisele
   tehnice ale producatorilor (taskul din Notion „Add per-collection info button…",
   2026-10-06).

   Hex-ul fiecarei culori (colors: [cod, hex]) e culoarea in care se citeste placa ei din
   aplicatie (media pixelilor thumbnail-ului). Sursa lui e Shopify: metaobiectele „Culoare
   swatch", editabile in admin (Content → Metaobjects), aduse in pagina de
   snippets/ixaria-swatch-colors.liquid si aplicate de adoptShopColors (mai jos), tot de acolo
   le ia si filtrul de culoare din PLP. Valorile de aici sunt rezerva, pentru o culoare fara
   intrare in Shopify; un hex din snapshot-ul aplicatiei (presentation.color,
   ixAdoptSwatchColors) se ia doar pentru o culoare pe care Shopify nu o are. */

/* ══════════ Data (copied verbatim from mobile-v2.html:1427-1530) ══════════ */
window.IX_COLLECTIONS = {
  luna: { name:'Luna', assetSlug:'lunareal', tier:'Practic', finish:'Matte', surface:'Textured', materialTypes:['Texturat'],
    waterproof:false, easyClean:false, petFriendly:false,
    composition:'100% poliester', width:145, weight:493, martindale:'90.000',
    mace:null, rubbing:null, light:'5', pilling:'4-5',
    fireTest:'Test cu țigara aprinsă', certifications:'Piele sensibilă (OEKO-TEX®)',
    desc:'Luna este o țesătură groasă, fără proprietăți speciale, cu care lucrăm de mult timp. Culorile vibrante și cu aspect mat oferă un efect simplu și modern.',
    care:'Aspirați regulat cu o perie moale și ștergeți imediat petele cu o cârpă curată și uscată, fără a freca. Folosiți doar produse de curățare delicate, pe bază de apă, și evitați expunerea directă la soare pentru a preveni decolorarea.',
    heroCode:'08',
    colors:[['01','#D0D1CC'],['08','#362F2D'],['14','#635047'],['15','#807876'],['16','#126D89'],['17','#8F8B39'],['21','#C6BDAA'],['24','#3E1F31'],['27','#302423'],['30','#25323F'],['31','#959692'],['32','#393D40'],['33','#A39990'],['34','#6D6764'],['35','#404040'],['36','#161715'],['41','#2C2828'],['60','#7C1C27'],['78','#6C2B48'],['85','#2B4049'],['96','#222222']]
  },
  manila: { name:'Manila', tier:'Practic', finish:'Glossy', surface:'Plush/Soft', materialTypes:['Efect catifea'],
    waterproof:false, easyClean:false, petFriendly:false,
    composition:'100% poliester', width:143, weight:220, martindale:'58.000',
    mace:null, rubbing:null, light:'4-5', pilling:'5',
    fireTest:'Test cu țigara aprinsă', certifications:'Fără AZO/DMF',
    desc:'Imitație de catifea, Manila impresionează cu un aspect elegant și ușor lucios. Creează umbre subtile și reprezintă o opțiune accesibilă pentru un efect de catifea la un preț redus.',
    care:'Aspirați regulat cu o perie moale, în sensul firului, pentru a menține aspectul plușat. Ștergeți imediat petele cu o cârpă curată și uscată, fără a freca, și evitați expunerea directă la soare pentru a preveni decolorarea.',
    heroCode:'08',
    colors:[['00','#EEEFE9'],['01','#F3EFE3'],['02','#ABA291'],['03','#908776'],['04','#30211C'],['05','#5A4C41'],['06','#43262A'],['07','#422D32'],['08','#8E8381'],['09','#CDB4BA'],['10','#ABCAC5'],['11','#8AB0A3'],['12','#4D6160'],['13','#CFCEC9'],['14','#C4C0B7'],['15','#94948A'],['16','#767573'],['17','#5B5C54'],['18','#2E2F29'],['19','#494947'],['20','#56626E'],['21','#857264'],['22','#453832'],['23','#982F33'],['25','#103440'],['26','#0E2944'],['27','#274452'],['28','#AF292A'],['29','#896157'],['30','#B98669'],['31','#955A2E'],['32','#D19B45'],['33','#AF862C'],['34','#53512B'],['35','#163629'],['36','#4D6F61'],['37','#0E5653'],['38','#516F6D'],['39','#32578E'],['40','#79733F'],['41','#7EAF5E']]
  },
  enjoylux: { name:'Enjoy Lux', tier:'Confort', finish:'Matte', surface:'Smooth', materialTypes:['Neted'],
    waterproof:true, easyClean:true, petFriendly:false,
    composition:'92% poliester, 8% nylon', width:146, weight:467, martindale:'55.000',
    mace:null, rubbing:'4-5/5', light:'5', pilling:'5',
    fireTest:'BS 5852: Partea 1', certifications:'Piele sensibilă (OEKO-TEX®)',
    desc:'Această țesătură mată, fină și impermeabilă este nu doar confortabilă, ci și ușor de curățat, făcând-o o alegere practică pentru uz zilnic. Enjoy Lux oferă o paletă de culori pastelată, modernă.',
    care:'Datorită tratamentului hidrofob, majoritatea petelor se îndepărtează ușor cu o cârpă umedă, fără a fi nevoie de produse speciale. Aspirați regulat pentru a menține textura și evitați expunerea prelungită la soare directă.',
    heroCode:'04',
    colors:[['01','#C9C2BA'],['02','#B2A191'],['03','#9B8F8F'],['04','#463C33'],['05','#3C3434'],['06','#252121'],['07','#8A8077'],['08','#45413E'],['09','#49413F'],['10','#857E29'],['11','#B5993C'],['12','#C08336'],['13','#993C2E'],['14','#5F323C'],['15','#2E2A2F'],['16','#69174E'],['17','#284E56'],['18','#608480'],['19','#B19597'],['20','#AEAEAE'],['21','#8C8B90'],['22','#40494A'],['23','#4A4A4A'],['24','#323136'],['25','#252325']]
  },
  milton: { name:'Milton', tier:'Premium', finish:'Semi-Glossy', surface:'Smooth', materialTypes:['Neted'],
    waterproof:true, easyClean:false, petFriendly:false,
    composition:'97% poliester, 3% nylon', width:140, weight:300, martindale:'90.000',
    mace:null, rubbing:null, light:'4', pilling:'5',
    fireTest:'BS 5852: Partea 1', certifications:null,
    desc:'Cu o textură fină, Milton New este o țesătură foarte elegantă și impermeabilă, lăsând umbre ușoare pe suprafața materialului. Acest tip de țesătură îl recomandăm atât pentru casă, cât și pentru produsele destinate HoReCa.',
    care:'Ștergeți petele imediat cu o cârpă curată, ușor umezită, fără a freca. Datorită finisajului hidrofob, lichidele nu pătrund imediat în material. Aspirați regulat cu o perie moale pentru a menține aspectul țesăturii și evitați expunerea prelungită la soare.',
    heroCode:'01',
    colors:[['01','#D3C2B9'],['02','#D1BFB6'],['03','#BEAB9C'],['04','#756362'],['05','#483C3C'],['06','#2B2724'],['07','#925437'],['08','#8A3A40'],['09','#552330'],['10','#5A2655'],['11','#8A7642'],['12','#2A5357'],['13','#283444'],['14','#70716C'],['15','#4E4A4B'],['16','#292929'],['17','#4B4A4F'],['18','#161F18'],['19','#1D2A2E'],['20','#1B1B32'],['21','#A5C4B5'],['22','#8F9EA5'],['23','#D7BEC2'],['24','#536A5E'],['25','#899CA9'],['26','#556C76'],['27','#5A5533'],['28','#AC6B41'],['29','#AC9B93'],['30','#C1B6B1'],['31','#E8E4E1'],['32','#AC8F88'],['33','#562F36']]
  },
  piano: { name:'Piano', tier:'Lux', finish:'Glossy', surface:'Plush/Soft', materialTypes:['Catifea'],
    waterproof:true, easyClean:true, petFriendly:false,
    composition:'100% poliester', width:142, weight:310, martindale:'60.000',
    mace:null, rubbing:null, light:'4-5', pilling:'4',
    fireTest:'BS 5852: Partea 1', certifications:null,
    desc:'Piano este o catifea elegantă, cu proprietăți de curățare ușoară, rezistentă și extrem de elegantă cu culori vibrante. Având în vedere proprietățile sale speciale de Easy Clean și impermeabilitate, noi îl recomandăm atât pentru încăperile care caută să ofere un aer elegant, cât și în domeniul HoReCa.',
    care:'Datorită tratamentului hidrofob, majoritatea petelor se îndepărtează ușor cu o cârpă umedă, fără a fi nevoie de produse speciale. Aspirați regulat pentru a menține textura și evitați expunerea prelungită la soare directă.',
    heroCode:'04',
    colors:[['01','#F3F1E5'],['02','#ECE2D6'],['03','#E1C8AF'],['04','#B7A69F'],['05','#665452'],['06','#5E2534'],['07','#BD8911'],['08','#074B30'],['09','#537368'],['10','#114B54'],['11','#90ABB8'],['12','#1B1D32'],['13','#CDC3BA'],['14','#909497'],['15','#5A5453'],['16','#130F0E'],['17','#101010'],['18','#5B4947'],['19','#484848'],['20','#82615C'],['21','#784218'],['22','#8D7668'],['23','#7C622F'],['24','#3D4144'],['25','#585836'],['26','#28362A'],['28','#2E3841']]
  },
  spello: { name:'Spello', tier:'Lux', finish:'Matte', surface:'Textured', materialTypes:['Texturat'],
    waterproof:true, easyClean:false, petFriendly:false,
    composition:'100% poliester', width:142, weight:430, martindale:'40.000',
    mace:null, rubbing:null, light:'3-4', pilling:'4',
    fireTest:'BS 5852: Partea 1', certifications:null,
    desc:'Spello este o țesătură groasă, cu textură proeminentă și impermeabilă. Este recomandat în special în momentele în care doriți un material texturat, gros și extrem de fiabil.',
    care:'Ștergeți petele imediat cu o cârpă curată, ușor umezită, fără a freca. Datorită finisajului hidrofob, lichidele nu pătrund imediat în material. Aspirați regulat cu o perie moale pentru a menține aspectul țesăturii și evitați expunerea prelungită la soare.',
    heroCode:'04',
    colors:[['04','#B39460'],['05','#A28982'],['06','#6B414B'],['08','#616871'],['09','#2C3D44'],['10','#738174'],['13','#686964']]
  },
  maya: { name:'Maya', tier:'Special', finish:'Semi-Glossy', surface:'Plush/Soft', materialTypes:['Efect catifea'],
    waterproof:true, easyClean:true, petFriendly:true,
    composition:'100% poliester', width:140, weight:350, martindale:'45.000',
    mace:'5/5', rubbing:null, light:'4', pilling:'4',
    fireTest:'BS 5852: Partea 1', certifications:null,
    desc:'Material elegant, cu aspect de catifea și model ușor țesut, deosebit. Foarte rezistent la gheruțele pisicilor, iar părul de animale se curăță foarte ușor. Prietenos pentru animale și ușor de curățat cu apă. Recomandăm în special pentru persoanele cu animale de casă, copii jucăuși, și pentru domeniul HoReCa.',
    care:'Datorită tratamentului hidrofob, majoritatea petelor se îndepărtează ușor cu o cârpă umedă, fără a fi nevoie de produse speciale. Aspirați regulat pentru a menține textura și evitați expunerea prelungită la soare directă.',
    heroCode:'03',
    colors:[['01','#C9C2B8'],['02','#DCD6C2'],['03','#DACCB9'],['04','#B3915B'],['05','#CC9543'],['06','#845F4A'],['07','#393F1C'],['08','#293736'],['09','#282C38'],['10','#273342'],['11','#525659'],['12','#606577'],['13','#88A2A1'],['14','#6D827E'],['15','#B5998D'],['16','#7B6460'],['17','#5C5050'],['18','#706663'],['19','#807875'],['20','#ABA9A5'],['21','#676766'],['22','#2F2C2D']]
  },
  zoya: { name:'Zoya', tier:'Special', finish:'Matte', surface:'Plush/Soft', materialTypes:['Efect catifea'],
    waterproof:true, easyClean:true, petFriendly:true,
    composition:'100% poliester', width:140, weight:390, martindale:'50.000',
    mace:'5/5', rubbing:null, light:'4-5', pilling:'5',
    fireTest:'BS 5852: Partea 1', certifications:null,
    desc:'Material elegant, cu aspect de catifea mată și culori elegante. Extrem de rezistent la uzură și scămoșare. Nu se agață de gheruțele pisicilor, iar părul de animale se curăță foarte ușor. Prietenos pentru animale și ușor de curățat cu apă. Recomandăm în special pentru persoanele cu animale de casă, copii jucăuși, și pentru domeniul HoReCa.',
    care:'Datorită tratamentului hidrofob, majoritatea petelor se îndepărtează ușor cu o cârpă umedă, fără a fi nevoie de produse speciale. Aspirați regulat pentru a menține textura și evitați expunerea prelungită la soare directă.',
    heroCode:'01',
    colors:[['01','#BCBDB7'],['02','#ABA7A4'],['03','#8C797B'],['04','#483437'],['05','#4D4543'],['06','#1C2E2C'],['07','#4B5858'],['08','#586561'],['09','#2F3336'],['10','#595D60'],['11','#676768'],['12','#9FA3A2'],['13','#886934'],['14','#414530'],['15','#293748']]
  }
};

/* Descrierile din editorul de teme (window.IX_COLLECTIONS_DATA.desc): un camp golit
   pastreaza textul de mai sus. */
(function(){
  var d = window.IX_COLLECTIONS_DATA && window.IX_COLLECTIONS_DATA.desc;
  if (!d) return;
  Object.keys(d).forEach(function(slug){
    var c = window.IX_COLLECTIONS[slug];
    var t = d[slug] && String(d[slug]).replace(/\s+/g, ' ').trim();
    if (c && t) c.desc = t;
  });
})();

/* ══════════ Culorile placilor: ordinea lor si hex-ul din aplicatie ══════════ */
(function(){
  /* CIE L*C*h, cu aceleasi constante ca rgbToLab din configurator */
  function lch(hex){
    var n = parseInt(String(hex).slice(1), 16);
    function lin(c){ c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
    function f(t){ return t > 0.008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116; }
    var r = lin(n >> 16 & 255), g = lin(n >> 8 & 255), b = lin(n & 255);
    var fx = f((r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.9505);
    var fy = f(r * 0.2126 + g * 0.7152 + b * 0.0722);
    var fz = f((r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.089);
    var A = 500 * (fx - fy), B = 200 * (fy - fz);
    var h = Math.atan2(B, A) * 180 / Math.PI;
    return { l: 116 * fy - 16, c: Math.sqrt(A * A + B * B), h: h < 0 ? h + 360 : h };
  }

  /* Ordinea culorilor dintr-o colectie, ca intr-un mostrar: intai albul, crem-ul si celelalte
     neutre deschise; apoi culorile pe roata cromatica, in felii de 30° pornind de la galben spre
     rosu (galben si bej, maro, rosu, roz, mov, albastru, petrol, verde, oliv), fiecare felie de
     la deschis la inchis; la sfarsit gri-urile, de la deschis pana la negru. Neutre sunt
     culorile cu croma mica, ca la filtrul de culoare din configurator (cfg_colorFamilyRO: sub 7
     la nuantele calde, sub 12 la cele reci), iar cele foarte deschise (L* >= 70) pana la 12, ca
     un crem sa stea langa alb, nu printre galbene. Doar de la deschis la inchis, cum era,
     nuanta sarea la fiecare placa. */
  function orderKey(hex){
    var p = lch(hex);
    var cool = p.h >= 100 && p.h < 310;
    if (p.l < 12 || p.c < (cool || p.l >= 70 ? 12 : 7)) return [p.l >= 70 ? 0 : 2, 0, -p.l];
    return [1, Math.floor(((460 - p.h) % 360) / 30), -p.l];
  }
  window.ixCompareSwatchHex = function(a, b){
    var ka = orderKey(a), kb = orderKey(b);
    return ka[0] - kb[0] || ka[1] - kb[1] || ka[2] - kb[2];
  };

  function sortColors(c){
    c.colors.sort(function(a, b){ return window.ixCompareSwatchHex(a[1], b[1]); });
  }
  Object.keys(window.IX_COLLECTIONS).forEach(function(slug){ sortColors(window.IX_COLLECTIONS[slug]); });

  /* Hex-ul din aplicatie (presentation.color), dupa numele materialului („Luna 08"): din
     snapshot-ul produsului (originalMaterialMap, ixaria-pdp-data.js) sau din regulile
     motorului (ixaria-figaro-bridge.js). Ia locul celui de rezerva, colectia se reordoneaza,
     iar evenimentul ix:swatch-colors anunta configuratorul sa refaca grila. Intoarce cate
     culori s-au schimbat. */
  var byName = null;
  function nameIndex(){
    if (!byName){
      byName = {};
      Object.keys(window.IX_COLLECTIONS).forEach(function(slug){
        var c = window.IX_COLLECTIONS[slug];
        c.colors.forEach(function(pair){
          byName[(c.name + ' ' + pair[0]).toLowerCase()] = { slug: slug, pair: pair };
        });
      });
    }
    return byName;
  }
  /* culorile al caror hex vine din Shopify (mai jos): snapshot-ul nu le mai schimba */
  var fromShop = {};
  window.ixAdoptSwatchColors = function(materials){
    nameIndex();
    var list = Array.isArray(materials) ? materials
      : Object.keys(materials || {}).map(function(id){ return materials[id]; });
    var slugs = [], count = 0;
    list.forEach(function(m){
      var p = m && m.presentation;
      var hex = p && p.color;
      if (!/^#[0-9a-f]{6}$/i.test(hex || '')) return;
      var key = String(m.name || '').trim().toLowerCase();
      var hit = byName[key] || byName[(key = String(p.name || '').trim().toLowerCase())];
      if (!hit || fromShop[key] || hit.pair[1] === hex.toUpperCase()) return;
      hit.pair[1] = hex.toUpperCase();
      count++;
      if (slugs.indexOf(hit.slug) < 0) slugs.push(hit.slug);
    });
    if (!count) return 0;
    slugs.forEach(function(slug){ sortColors(window.IX_COLLECTIONS[slug]); });
    console.info('[ixaria] hex din aplicatie pentru ' + count + ' culori (' + slugs.join(', ') + ')');
    document.dispatchEvent(new CustomEvent('ix:swatch-colors', { detail: { slugs: slugs } }));
    return count;
  };

  /* Hex-ul din Shopify: metaobiectele „Culoare swatch" (IX_COLLECTIONS_DATA.swatches,
     snippets/ixaria-swatch-colors.liquid), editabile in admin. Au ultimul cuvant, si peste
     valorile de aici, si peste cele din snapshot-ul aplicatiei. Se aplica o data, la
     incarcare, inainte ca pagina sau configuratorul sa citeasca IX_COLLECTIONS, deci ordinea
     culorilor (ixCompareSwatchHex) se face direct pe ele: o culoare care sta prost in rand se
     muta corectandu-i hex-ul in admin. */
  (function adoptShopColors(){
    var rows = window.IX_COLLECTIONS_DATA && window.IX_COLLECTIONS_DATA.swatches;
    if (!Array.isArray(rows) || !rows.length) return;
    var index = nameIndex(), slugs = [];
    rows.forEach(function(row){
      var key = String((row && row[1]) || '').trim().toLowerCase();
      var hex = String((row && row[2]) || '').trim().toUpperCase();
      var hit = index[key];
      if (!hit || !/^#[0-9A-F]{6}$/.test(hex)) return;
      fromShop[key] = true;
      if (hit.pair[1] === hex) return;
      hit.pair[1] = hex;
      if (slugs.indexOf(hit.slug) < 0) slugs.push(hit.slug);
    });
    slugs.forEach(function(slug){ sortColors(window.IX_COLLECTIONS[slug]); });
  })();
})();

function ixEsc(s){
  return String(s == null ? '' : s).replace(/[&<>"]/g, function(ch){
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
  });
}

/* Proprietatile cu iconita: aceleasi iconite in fereastra colectiei, la filtrele „Proprietăți"
   din configurator si in casetele „lifestyle" de pe pagina produsului
   (snippets/ixaria-benefit-icon.liquid). Fisierele sunt in temă (assets/ix-prop-*); adresele
   le pune ixaria-collections-data.liquid. Ordinea e a lui Eduard (Notion, 2026-10-06: „Easy
   Clean, Pet friendly, impermeabil, OEKO-TEX® in ordinea asta"), aceeasi ca in randul de sub
   numele colectiei (cfg_collectionPerks); OEKO-TEX® are Luna si Enjoy Lux. */
window.IX_PROPS = [
  { key: 'easyClean', label: 'Easy Clean' },
  { key: 'petFriendly', label: 'Pet-friendly' },
  { key: 'waterproof', label: 'Impermeabil' },
  { key: 'oekoTex', label: 'OEKO-TEX®', test: function(c){ return window.ixHasOekoTex(c); } }
];
window.ixHasProp = function(c, p){
  return p.test ? p.test(c) : !!c[p.key];
};
window.ixPropIcon = function(key, size){
  var icons = (window.IX_COLLECTIONS_DATA && window.IX_COLLECTIONS_DATA.icons) || {};
  if (!icons[key]) return '';
  size = size || 24;
  return '<img class="ix-prop-ico" src="' + icons[key] + '" alt="" width="' + size + '" height="' + size + '" aria-hidden="true">';
};
window.ixHasOekoTex = function(c){
  return !!(c && c.certifications && c.certifications.indexOf('OEKO-TEX') > -1);
};

/* „Detalii" din fereastra colectiei (in Figma „Features"; Eduard: „Schimba Features in
   detalii"). Textele de la (i) sunt ale lui Eduard (Notion), mai putin cel de la Pilling, pe
   care Figma il are, dar taskul nu il scrie. Notele de la Pilling si lumina urmeaza scara din
   task; o nota intre doua (4-5) ia eticheta celei de jos, iar una fara eticheta in task (3-4
   la lumina) ramane doar cu cifra. `k` e eticheta asa cum o arata Figma („Rezistență" si „la
   lumină" pe doua randuri), `name` aceeasi pe un rand (titlul explicatiei, aria-label). */
var IX_FEAT_INFO = {
  martindale: 'Măsoară rezistența unei țesături la uzură și frecare, exprimată în număr de cicluri, indicând cât de durabil este materialul în timp.',
  pilling: 'Arată cât de bine rezistă țesătura la formarea scamelor (bobițelor) pe suprafață, în urma frecării. Nota merge de la 1 la 5: cu cât e mai mare, cu atât apar mai puține scame.',
  light: 'Capacitatea țesăturii de a-și păstra culoarea originală atunci când este expusă la razele soarelui sau la lumină artificială intensă.'
};
var IX_PILLING_NOTE = { 3: 'standard', 4: 'excelent', 5: 'excepțional' };
var IX_LIGHT_NOTE = { 4: 'ideal pentru lumină indirectă', 5: 'ideal pentru acasă' };
function ixGradeNote(v, notes){
  return notes[parseInt(v, 10)] || '';
}
window.ixCollectionFeatures = function(c){
  var rows = [];
  if (c.martindale) rows.push({ key: 'martindale', name: 'Martindale', k: 'Martindale', info: IX_FEAT_INFO.martindale, v: c.martindale + ' cicluri' });
  if (c.pilling) rows.push({ key: 'pilling', name: 'Pilling', k: 'Pilling', info: IX_FEAT_INFO.pilling, v: c.pilling, note: ixGradeNote(c.pilling, IX_PILLING_NOTE) });
  if (c.light) rows.push({ key: 'light', name: 'Rezistență la lumină', k: 'Rezistență<br>la lumină', info: IX_FEAT_INFO.light, v: c.light, note: ixGradeNote(c.light, IX_LIGHT_NOTE) });
  if (window.ixHasOekoTex(c)) rows.push({ key: 'cert', name: 'Certificări', k: 'Certificări', v: 'OEKO-TEX®', note: 'fără substanțe nocive', stack: true });
  if (c.composition) rows.push({ key: 'comp', name: 'Compoziție', k: 'Compoziție', lines: c.composition.split(/\s*,\s*/) });
  return rows;
};

var IX_CS_INFO_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M6 8V6M6 4H6.005M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var IX_CS_SAMPLE_SVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M13.3333 13.3333L15 15L18.3333 11.6667M17.5 8.33325V6.66659C17.4997 6.37431 17.4225 6.08726 17.2763 5.83422C17.13 5.58118 16.9198 5.37105 16.6667 5.22492L10.8333 1.89159C10.58 1.7453 10.2926 1.66829 10 1.66829C9.70744 1.66829 9.42003 1.7453 9.16667 1.89159L3.33333 5.22492C3.08022 5.37105 2.86998 5.58118 2.72372 5.83422C2.57745 6.08726 2.5003 6.37431 2.5 6.66659V13.3333C2.5003 13.6255 2.57745 13.9126 2.72372 14.1656C2.86998 14.4187 3.08022 14.6288 3.33333 14.7749L9.16667 18.1083C9.42003 18.2545 9.70744 18.3315 10 18.3315C10.2926 18.3315 10.58 18.2545 10.8333 18.1083L12.5 17.1583M6.25 3.55835L13.75 7.85002M2.7417 5.83333L10 10M10 10L17.2584 5.83333M10 10L10 18.3333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var ixTipSeq = 0;
function ixFeatRow(r){
  var id = 'ixcs-tip-' + (++ixTipSeq);
  var v = r.lines
    ? r.lines.map(ixEsc).join('<br>')
    : '<b>' + ixEsc(r.v) + '</b>' + (r.note ? (r.stack ? '<br>' : ' ') + '(' + r.note + ')' : '');
  return '<div class="ixcs-row">' +
    '<div class="ixcs-k"><span class="ixcs-kt">' + r.k + '</span>' +
      (r.info ? '<button type="button" class="ixcs-i" aria-expanded="false" aria-controls="' + id + '" aria-label="Ce înseamnă: ' + r.name + '" onclick="ixcsTip(this)">' + IX_CS_INFO_SVG + '</button>' : '') +
    '</div>' +
    '<div class="ixcs-v"><span class="ixcs-vt' + (r.lines || r.stack ? ' is-reg' : '') + '">' + v + '</span></div>' +
    (r.info ? '<div class="ixcs-tip" id="' + id + '" role="tooltip" hidden><i class="ixcs-tip-arrow" aria-hidden="true"></i><b>' + r.name + '</b><p>' + r.info + '</p></div>' : '') +
  '</div>';
}

/* (i) de langa un rand: explicatia apare intr-o fereastra mica, sub iconita, cu sageata spre
   ea (Eduard: „ar trebui sa apara un pop-up estetic, placut", nu text pus sub rand). Una
   singura deschisa; se inchide la a doua apasare pe (i), la o apasare in afara ei sau cu
   Escape. Sta in randul ei (position: absolute), deci se deruleaza odata cu fereastra. */
function ixcsCloseTips(except){
  Array.prototype.forEach.call(document.querySelectorAll('.ixcs-tip:not([hidden])'), function(tip){
    if (tip === except) return;
    tip.hidden = true;
    var row = tip.closest('.ixcs-row');
    if (row) row.classList.remove('tip-open');
    /* butonul care o deschide (un rand poate avea mai multe, ca detaliile din sectiunea
       „Materiale" a paginii de produs) */
    var btn = (tip.id && document.querySelector('[aria-controls="' + tip.id + '"]')) || (row && row.querySelector('.ixcs-i'));
    if (btn) btn.setAttribute('aria-expanded', 'false');
  });
}
window.ixcsTip = function(btn){
  var tip = document.getElementById(btn.getAttribute('aria-controls'));
  if (!tip) return;
  var open = tip.hidden;
  ixcsCloseTips(tip);
  tip.hidden = !open;
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  var row = btn.closest('.ixcs-row');
  if (row) row.classList.toggle('tip-open', open);
  if (!open || !row) return;
  /* Deasupra iconitei, cu varful sagetii in dreptul centrului ei: pe telefon degetul care a
     apasat ar acoperi o fereastra deschisa dedesubt (cerut 2026-10-06). Sub iconita doar cand
     sus nu e loc in partea vizibila a panoului care se deruleaza (un rand chiar sus). */
  var r = row.getBoundingClientRect(), b = btn.getBoundingClientRect();
  var top = 0;
  for (var el = row.parentElement; el && el !== document.body; el = el.parentElement) {
    var oy = getComputedStyle(el).overflowY;
    if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight) {
      top = el.getBoundingClientRect().top;
      break;
    }
  }
  var below = b.top - tip.offsetHeight - 10 < Math.max(0, top);
  tip.classList.toggle('is-below', below);
  tip.style.top = below ? Math.round(b.bottom - r.top + 10) + 'px' : '';
  tip.style.bottom = below ? '' : Math.round(r.bottom - b.top + 10) + 'px';
  tip.style.setProperty('--ixcs-ax', Math.round(b.left - r.left + b.width / 2 - 6) + 'px');
};
document.addEventListener('click', function(e){
  if (!document.querySelector('.ixcs-tip:not([hidden])')) return;
  if (e.target.closest && e.target.closest('.ixcs-i, .ixcs-tip')) return;
  ixcsCloseTips();
}, true);
document.addEventListener('keydown', function(e){
  if (e.key === 'Escape') ixcsCloseTips();
});

/* Pozele de sus ale ferestrei (Figma 165:1012): una pe toata latimea, patrate, trase lateral,
   cu liniutele de 27 x 2px peste ele cand sunt mai multe. photos = [{ src, name, hex }]: hex e
   fondul cat se incarca poza, name e alt-ul. Liniuta curenta o tine la zi ascultatorul de mai
   jos, pentru orice .ixcs-track din pagina, deci locul care le pune nu mai leaga nimic. */
window.ixCollectionSheetPhotos = function(photos){
  photos = photos || [];
  return '<div class="ixcs-photos">' +
    '<div class="ixcs-track">' + photos.map(function(p){
      return '<div class="ixcs-photo"' + (p.hex ? ' style="background-color:' + ixEsc(p.hex) + '"' : '') + '>' +
        (p.src ? '<img src="' + ixEsc(p.src) + '" alt="' + ixEsc(p.name || '') + '" decoding="async">' : '') +
      '</div>';
    }).join('') + '</div>' +
    (photos.length > 1 ? '<div class="ixcs-dots" aria-hidden="true">' + photos.map(function(_, k){
      return '<i' + (k ? '' : ' class="on"') + '></i>';
    }).join('') + '</div>' : '') +
  '</div>';
};
document.addEventListener('scroll', function(e){
  var t = e.target;
  if (!t || !t.classList || !t.classList.contains('ixcs-track')) return;
  var dots = t.parentNode.querySelector('.ixcs-dots');
  if (!dots) return;
  var k = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
  Array.prototype.forEach.call(dots.children, function(d, i){ d.classList.toggle('on', i === k); });
}, true);

/* Continutul ferestrei unei colectii (Figma 165:1012), sub poze: titlul (optional), descrierea,
   randul cu proprietati, „Detalii", „Îngrijire material" si butonul de mostre, cu spatiile din Figma (padding-ul lui
   .ixcs e al ferestrei: 20px sub poza si pe laterale, 40px la final). Il folosesc fereastra din
   configurator (openCollectionDetail) si panoul de pe pagina produsului (openMaterialInfo), ca
   sa arate la fel; stilurile sunt in assets/ixaria-collection-sheet.css. Fara proprietati
   (Manila) randul lipseste. Butonul de mostre ramane ascuns cat regula „Mostre: ascunse
   deocamdata" (onclick*="openSamplesModal") e in CSS. „Îngrijire material" (readaugata
   2026-10-13): textul de ingrijire al colectiei (c.care), sub „Detalii", in formatul lor. */
window.ixCollectionSheetBody = function(c, opts){
  opts = opts || {};
  var perks = window.IX_PROPS.filter(function(p){ return window.ixHasProp(c, p); });
  var feats = window.ixCollectionFeatures(c);
  return '<div class="ixcs">' +
    (opts.title ? '<h2 class="ixcs-title">Colecția ' + ixEsc(c.name) + '</h2>' : '') +
    '<p class="ixcs-desc">' + ixEsc(c.desc) + '</p>' +
    (perks.length ? '<div class="ixcs-perks">' + perks.map(function(p){
      return '<div class="ixcs-perk">' + window.ixPropIcon(p.key, 24) + '<span>' + p.label + '</span></div>';
    }).join('<span class="ixcs-vr" aria-hidden="true"></span>') + '</div>' : '') +
    (feats.length ? '<div class="ixcs-feats"><h3 class="ixcs-h">Detalii</h3><div class="ixcs-rows">' + feats.map(ixFeatRow).join('') + '</div></div>' : '') +
    (c.care ? '<div class="ixcs-care"><h3 class="ixcs-h">Îngrijire material</h3><p class="ixcs-desc">' + ixEsc(c.care) + '</p></div>' : '') +
    (opts.sampleOnclick ? '<button type="button" class="ixcs-cta" onclick="' + opts.sampleOnclick + '">' + IX_CS_SAMPLE_SVG + '<span>Comandă mostrar</span></button>' : '') +
  '</div>';
};
